import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    ReferenceField,
    TopToolbar,
    ShowButton,
    EditButton,
    useRecordContext,
    ReferenceManyField,
    Pagination,
    Datagrid,
    RichTextField
} from 'react-admin';
import {
    Box,
    Grid
} from '@mui/material';

const ShowActions = () => {
    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowUrlTitle = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{ "Websites - " + record.id }</span>
}

export const AdminWebsiteShow = () => {
    return(
        <Box sx={ { flexGrow: 1, padding: '0 16px 0 16px' } }>
            <Grid container spacing={ 2 }>
                <Grid size={ 12 }>
                    <Show actions={ <ShowActions /> } title={ <ShowUrlTitle /> }>
                        <Grid container spacing={ 2 }>
                            <Grid size={ 6 }>
                                <SimpleShowLayout>
                                    <TextField source="baseUrl" />
                                    <ReferenceField
                                        label="Company"
                                        source="company"
                                        reference="companies"
                                        link="edit">
                                        <TextField source="name" />
                                    </ReferenceField>
                                </SimpleShowLayout>
                            </Grid>
                            <Grid size={ 6 }>
                                <SimpleShowLayout>
                                    <RichTextField
                                        source="aboutPageContent"  />
                                </SimpleShowLayout>
                            </Grid>
                        </Grid>
                    </Show>
                </Grid>
            </Grid>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <Show title=" " actions={ false }>
                        <Box sx={ { padding: '5px 10px 5px 10px', fontSize: '24px' } }>
                            <span>Urls</span>
                        </Box>
                        <ReferenceManyField
                            label="Urls"
                            source="urls"
                            reference="urls"
                            target="id"
                            pagination={ <Pagination /> }
                        >
                            <Datagrid bulkActionButtons={ false } >
                                <TextField source="id" />
                                <TextField source="path" />
                                <>
                                    <ShowButton />
                                    <EditButton />
                                </>
                            </Datagrid>
                        </ReferenceManyField>
                    </Show>
                </Grid>
            </Grid>
        </Box>
    );
}